export interface SortType {
    field: string;
    isReversed?: boolean;
    text: string;
}

export const getOrderingValue = (sortType: SortType): string =>
    `${sortType.isReversed ? "" : "-"}${sortType.field}`;

export const ProductOrderSortTypes: SortType[] = [
    {
        field: "last_modified",
        text: "Cập nhật mới nhất",
    },
    {
        field: "last_modified",
        text: "Cập nhật cũ nhất",
        isReversed: true,
    },
    {
        field: "due_date",
        text: "Ngày đến hạn gần nhất",
    },
    {
        field: "due_date",
        text: "Ngày đến hạn xa nhất",
        isReversed: true,
    },
    {
        field: "customer__name",
        text: "Tên khách hàng từ A-Z",
        isReversed: true,
    },
    {
        field: "customer__name",
        text: "Tên khách hàng từ Z-A",
    },
];

export const CustomerExportSortTypes: {
    text: string;
    value?: number;
}[] = [
    {
        text: "Không chọn",
    },
    {
        text: "Tháng 1",
        value: 1,
    },
    {
        text: "Tháng 2",
        value: 2,
    },
    {
        text: "Tháng 3",
        value: 3,
    },
    {
        text: "Tháng 4",
        value: 4,
    },
    {
        text: "Tháng 5",
        value: 5,
    },
    {
        text: "Tháng 6",
        value: 6,
    },
    {
        text: "Tháng 7",
        value: 7,
    },
    {
        text: "Tháng 8",
        value: 8,
    },
    {
        text: "Tháng 9",
        value: 9,
    },
    {
        text: "Tháng 10",
        value: 10,
    },
    {
        text: "Tháng 11",
        value: 11,
    },
    {
        text: "Tháng 12",
        value: 12,
    },
];

export const MaterialSortTypes: SortType[] = [
    {
        field: "expired_date",
        text: "Ngày đến hạn gần nhất",
        isReversed: true,
    },
    {
        field: "expired_date",
        text: "Ngày đến hạn xa nhất",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Tồn thực tế nhiều nhất",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Tồn thực tế ít nhất",
        isReversed: true,
    },
    {
        field: "available_quantity",
        text: "Khả dụng nhiều nhất",
        isReversed: false,
    },
    {
        field: "available_quantity",
        text: "Khả dụng ít nhất",
        isReversed: true,
    },
];

export const ProductSortTypes: SortType[] = [
    {
        field: "name",
        text: "Tên từ A-Z",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ Z-A",
    },
    {
        field: "quantity",
        text: "Tồn kho tăng dần",
        isReversed: true,
    },
    {
        field: "quantity",
        text: "Tồn kho giảm dần",
    },
];

export const AddOnsSortTypes: SortType[] = [
    {
        field: "price",
        text: "Giá giảm dần",
        isReversed: false,
    },
    {
        field: "price",
        text: "Giá tăng dần",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ A-Z",
    },
    {
        field: "name",
        text: "Tên từ Z-A",
        isReversed: true,
    },
];

export const GroupedDeliveryTripsSortTypes: SortType[] = [
    {
        field: "vehicle_plate",
        text: "Biển số xe từ A-Z",
        isReversed: true,
    },
    {
        field: "vehicle_plate",
        text: "Biển số xe từ Z-A",
    },
        {
        field: "scheduled_at",
        text: "Ngày giao hàng gần nhất",
        isReversed: true,
    },
    {
        field: "scheduled_at",
        text: "Ngày giao hàng xa nhất",
        isReversed: false,
    },

];

export const ExtraFeesSortTypes: SortType[] = [
    {
        field: "price",
        text: "Giá giảm dần",
        isReversed: false,
    },
    {
        field: "price",
        text: "Giá tăng dần",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ A-Z",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ Z-A",
    },
];

export const CustomerSortTypes: SortType[] = [
    {
        field: "name",
        text: "Tên từ A-Z",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ Z-A",
    },
    {
        field: "tier",
        text: "Cấp độ từ thấp đến cao",
    },
    {
        field: "tier",
        text: "Cấp độ từ cao đến thấp",
        isReversed: true,
    },
    {
        field: "number_of_orders",
        text: "Số lượng đơn hàng từ cao đến thấp",
    },
    {
        field: "number_of_orders",
        text: "Số lượng đơn hàng từ thấp đến cao",
        isReversed: true,
    },
    {
        field: "total_products_purchased",
        text: "Tổng sản phẩm đã mua từ cao đến thấp",
    },
    {
        field: "total_products_purchased",
        text: "Tổng sản phẩm đã mua từ thấp đến cao",
        isReversed: true,
    },
];

export const MaterialOrderSortTypes: SortType[] = [
    {
        field: "created_at",
        text: "Ngày tạo gần nhất",
    },
    {
        field: "created_at",
        text: "Ngày tạo xa nhất",
        isReversed: true,
    },
    {
        field: "due_date",
        text: "Ngày đến hạn gần nhất",
        isReversed: true,
    },
    {
        field: "due_date",
        text: "Ngày đến hạn xa nhất",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Số lượng từ lớn đến nhỏ",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Số lượng từ nhỏ đến lớn",
    },
];

export const MaterialRequestSortTypes: SortType[] = [
    {
        field: "created_at",
        text: "Ngày tạo gần nhất",
    },
    {
        field: "created_at",
        text: "Ngày tạo xa nhất",
        isReversed: true,
    },
    {
        field: "due_date",
        text: "Ngày đến hạn gần nhất",
        isReversed: true,
    },
    {
        field: "due_date",
        text: "Ngày đến hạn xa nhất",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Số lượng từ lớn đến nhỏ",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Số lượng từ nhỏ đến lớn",
    },
];

export const OutsourceOrderSortTypes: SortType[] = [
    {
        field: "created_at",
        text: "Ngày tạo gần nhất",
    },
    {
        field: "created_at",
        text: "Ngày tạo xa nhất",
        isReversed: true,
    },
    {
        field: "due_date",
        text: "Ngày đến hạn gần nhất",
        isReversed: true,
    },
    {
        field: "due_date",
        text: "Ngày đến hạn xa nhất",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Số lượng từ lớn đến nhỏ",
        isReversed: false,
    },
    {
        field: "quantity",
        text: "Số lượng từ nhỏ đến lớn",
    },
];

export const ProviderSortTypes: SortType[] = [
    {
        field: "name",
        text: "Tên từ A-Z",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ Z-A",
    },
    {
        field: "number_of_orders",
        text: "Số lượng đơn hàng",
    },
    {
        field: "number_of_orders",
        text: "Số lượng đơn hàng",
        isReversed: true,
    },
];

export const EmployeeSortTypes: SortType[] = [
    {
        field: "display_name",
        text: "Tên nhân viên từ A-Z",
        isReversed: true,
    },
    {
        field: "display_name",
        text: "Tên nhân viên từ Z-A",
    },
];

export const MaterialsExportSortTypes: SortType[] = [
    {
        field: "created_at",
        text: "Ngày tạo gần nhất",
    },
    {
        field: "created_at",
        text: "Ngày tạo xa nhất",
        isReversed: true,
    },
];

export const MaterialsImportSortTypes: SortType[] = [
    {
        field: "created_at",
        text: "Ngày tạo gần nhất",
    },
    {
        field: "created_at",
        text: "Ngày tạo xa nhất",
        isReversed: true,
    },
];

export const ProductsExportSortTypes: SortType[] = [
    {
        field: "export_date",
        text: "Ngày xuất gần nhất",
    },
    {
        field: "export_date",
        text: "Ngày xuất xa nhất",
        isReversed: true,
    },
    {
        field: "created_at",
        text: "Ngày tạo gần nhất",
    },
    {
        field: "created_at",
        text: "Ngày tạo xa nhất",
        isReversed: true,
    },
];

export const ProductTransactionSortTypes: SortType[] = [
    {
        field: "transaction_date",
        text: "Ngày giao dịch gần nhất",
    },
    {
        field: "transaction_date",
        text: "Ngày giao dịch xa nhất",
        isReversed: true,
    },
];

export const ProductsImportSortTypes: SortType[] = [
    {
        field: "created_at",
        text: "Ngày tạo gần nhất",
    },
    {
        field: "created_at",
        text: "Ngày tạo xa nhất",
        isReversed: true,
    },
];
